import clsx from 'clsx';
import { useVoucherInfoActions } from '../../hooks/useVoucherInfoActions';
import { useVoucherDetailContext } from '../../PageVoucherDetail.context';
import { adaptVoucherInfo } from '../../utils/adaptVoucherInfo';
import { adaptListCondition } from '../SectionVoucherCondition/adaptListCondition';
import { ListCondition } from '../SectionVoucherCondition/ListCondition';
import { ProgressBar } from '../SectionVoucherCondition/ProgressBar';
import { VoucherInfo } from './VoucherInfo';

interface Props {
  background?: string;
  className?: string;
}

export const SectionVoucherInfo = ({ background, className }: Props) => {
  const { voucherInfo, isVoucherLoading, isStatusLoading, refetchVoucherInfo, condition } = useVoucherDetailContext();

  const { onCTAClick } = useVoucherInfoActions({
    callback: refetchVoucherInfo,
  });

  if (isVoucherLoading) return <div className="w-auto rounded bg-slate-200 animate-pulse h-[300px] m-6" />;

  if (!voucherInfo) return <div className="w-full h-[300px] bg-white flex justify-center items-center">Không tìm thấy thông tin mã khuyến mãi</div>;

  const adaptedListCondition = adaptListCondition(condition?.conditionMessages);
  const adaptedData = adaptVoucherInfo(voucherInfo);

  const progressBar = condition?.conditionMessages ? <ProgressBar percent={condition?.percentageCondition} /> : undefined;
  const conditionList = condition?.conditionMessages ? <ListCondition {...adaptedListCondition} /> : undefined;

  return (
    <div
      className={clsx('w-full rounded p-6 flex gap-6 bg-white', className)}
      style={{
        background,
      }}
    >
      <VoucherInfo
        onClick={voucherInfo.actionStatus === 'AVAILABLE' ? () => onCTAClick(voucherInfo.actionStatus, voucherInfo.code) : undefined}
        {...adaptedData}
        isStatusLoading={isStatusLoading}
        conditionList={conditionList}
        progressBar={progressBar}
      />
    </div>
  );
};

const MOCKUP_VOUCHER_INFO = {
  title: 'Voucher 100k',
  code: 'ABCDEF',
  expiredDate: '20/11/2025',
  usedPercent: 25,
  content: 'Áp dụng cho đơn hàng các sản phẩm Rohto Hadalabo/Sunplay/Ramos/Acnes/Oxy/Vichy/Lipice có giá trị từ 1.800.000đ',
  condition: 'Đã dùng: 25%',
};

